import { graphql } from '@/__generated__';
import { useQueryStable } from '../useQueryStable';

export const GetAccountProjects = graphql(/* GraphQL */ `
  query AccountProjects($accountId: BigInt!) {
    account(id: $accountId) {
      projects {
        accountId
        projectId
        coreProjectName
      }
    }
  }
`);

type AccountProjectProps = {
  accountId: number | undefined;
  pause?: boolean;
};

export const useAccountProjects = ({ accountId = 0, pause }: AccountProjectProps) => {
  const query = useQueryStable({
    query: GetAccountProjects,
    variables: { accountId },
    pause: pause || !accountId,
  });

  // TODO: we need a cachebusting strategy for Account-level queries

  return query;
};
